/**
 * Claves frecuentes en tiles de provincias (según el dataset que exportó el PMTiles).
 * El filtro de hover debe usar la MISMA clave y valor que devuelve el tile, no siempre "name".
 */
const PROVINCE_PROPERTY_KEYS = [
  'province_id',
  'province_name',
  'name',
  'NAME',
  'Name',
  'NOMPROV',
  'provincia',
  'PROVINCIA',
  'NAME_1',
  'fna',
  'nom_prov',
  'nm',
  'NM_PROV_',
  'NOM',
];

/**
 * @param {Record<string, unknown> | null | undefined} props
 * @returns {{ key: string, value: string | number } | null} par para armar un filter [==, get key, value]
 */
export function getProvinceIdentityForFilter(props) {
  if (!props || typeof props !== 'object') return null;
  for (const k of PROVINCE_PROPERTY_KEYS) {
    if (Object.prototype.hasOwnProperty.call(props, k)) {
      const v = props[k];
      if (v == null) continue;
      if (typeof v === 'string') {
        const s = v.trim();
        if (s.length > 0) return { key: k, value: s };
      } else if (typeof v === 'number' && !Number.isNaN(v)) {
        return { key: k, value: v };
      }
    }
  }
  for (const [k, v] of Object.entries(props)) {
    if (typeof v === 'string' && v.trim() !== '') return { key: k, value: v.trim() };
    if (typeof v === 'number' && !Number.isNaN(v)) return { key: k, value: v };
  }
  return null;
}

/**
 * Filtro MapLibre para resaltar UNA feature de provincia.
 * - Prioriza el id de la feature (estable en vector tiles cuando existe).
 * - Si no, compara con to-string: evita que falle 5 (number) vs "5" (string) en el tile.
 *
 * @param {{ id?: string | number, properties: Record<string, unknown> } | null | undefined} f
 *   feature de queryRenderedFeatures
 * @param {{ key: string, value: string | number } | null} identity
 */
export function buildProvinceHoverFilter(f, identity) {
  if (!identity) {
    return ['==', ['get', '__terrio_hover__'], '__on__'];
  }
  const { key, value } = identity;
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return ['==', ['get', key], value];
  }
  if (typeof value === 'string') {
    return ['==', ['get', key], value];
  }
  return ['==', ['to-string', ['get', key]], String(value)];
}

/**
 * Filtro que nunca pasa: hasta asignar un filtro activo vía setFilter.
 */
export const PROVINCE_HOVER_INACTIVE = ['==', ['get', '__terrio_hover__'], '__on__'];
